import { render } from "./AddToRecipe.vue?vue&type=template&id=2d562d77&scoped=true"
import script from "./AddToRecipe.vue?vue&type=script&lang=js"
export * from "./AddToRecipe.vue?vue&type=script&lang=js"

import "./AddToRecipe.vue?vue&type=style&index=0&id=2d562d77&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d562d77"]])

export default __exports__